<template>
  <div footer :style="bgColor ? `background-color:#${bgColor}` : ''">
    <div class="get-in-touch">
      <div class="intro">
        <p class="label">Get in Touch</p>
        <p class="headline">Tell us what you’re working on, where you want to go, <br>and how we can help.</p>
      </div>
      <div class="inquiry">
        <p class="title"><b>프로젝트 문의</b><span>Project Inquiries</span></p>
        <div class="body">
          <p>프로젝트 의뢰는 대략적인 의뢰 내용과 일정 및 예산 등을 체크하여 <br>검토 후 담당자가 빠르게 회신 드리겠습니다.</p>
          <a class="btn" role="button" @click="linkTo('/inquiry')">프로젝트 의뢰 <i></i></a>
        </div>
      </div>
    </div>
    <div class="inner-wrap">
      <p class="copyright">newtype imageworks <br>21, 132 gangnam-daero, gangnam-gu, Seoul Korea</p>
      <ul class="sns">
        <li><a href="mailto:hello@newtype.design" target="_blank">hello@newtype.design</a></li>
        <li><a href="https://www.instagram.com/newtypeimageworks/" target="_blank">Instagram</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  lexicon: 'footer',
  data() {
    return {
      sitemapOpen: false,
      langOpen: false,
    };
  },
  computed: {
    bgColor() {
      return this.$store.state.bgColor;
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';
// 상단 여백: 페이지 콘텐츠 ~ 'Get in Touch' = margin-top + padding-top
[footer] { .bgc(#fff); color: #888; .mt(80); .p(60, 0); .fs(14, 1.5); .medium;
  &.viewer, &.search { .hide; }
  .dark & { .bgc(#000); }

  .get-in-touch { .space-m; .mb(100); letter-spacing: -0.25px;
    // 폰트 크기는 About 등 본문의 .subtitle-text-vertical과 동일 (32 / 40 / 48 / 62)
    .intro { .fs(32, 1.3, -0.25); .regular;
      // 타이틀은 볼드 + 메인 색, 본문은 회색 (About 페이지 'Our Partners'와 같은 규칙)
      .label { .bold; color: #111; }
      .headline { color: #888;
        br { .hide; }
      }
    }
    .inquiry { .mt(50); .pt(50); .-t(#ebebeb); font-family: 'Pretendard', sans-serif; }
    .title { .fs(18, 1.5); .semi-bold;
      b { .block; .bold; color: #111; }
      span { .block; color: #888; }
    }
    .body { .mt(30);
      p { .fs(15, 1.7); .regular; color: #666;
        br { .hide; }
      }
      .btn { .cta-btn; .mt(30); }
    }
    .dark & {
      .intro .label { color: #e3e3e3; }
      .intro .headline { color: #888; }
      .inquiry { border-top-color: #3c3c3c; }
      .title b, .body p { color: #e3e3e3; }
    }
  }

  .inner-wrap { .space-m; }
  .sns { .mt(20); }
}
@media (min-width: @screen-tp-min) {
  [footer] { .mt(120); .p(90, 0, 40);
    .get-in-touch { .mb(160);
      .inquiry { .mt(100); .pt(30); .grid(2, 20); }
      .body { .mt(0); }
    }
    .inner-wrap { .grid(2, 20); }
    .sns { .mt(0); }
  }
}
@media (min-width: @screen-tl-min) {
  [footer] { .fs(17, 1.5);
    .get-in-touch {
      .intro { .fs(40, 1.3, -0.25);
        .headline br { .ib; }
      }
      .title { .fs(20, 1.5); }
      .body p { .fs(16, 1.7);
        br { .ib; }
      }
      .body .btn { .mt(40); }
    }
  }
}
// 디자인 기준 1920 (dm: 1440 ~ 1920)
@media (min-width: @screen-dm-min) {
  [footer] { .mt(164); .p(120, 0, 40);
    .get-in-touch { .space-d; .mb(220);
      .intro { .fs(48, 1.3, -0.25); }
      .inquiry { .mt(183); }
      .title { .fs(27, 1.5); letter-spacing: -0.27px; }
      .body p { .fs(18, 1.7); letter-spacing: -0.36px; }
    }
    .inner-wrap { .space-d; }
  }
}
@media (min-width: @screen-dx-min) {
  [footer] .get-in-touch .intro { .fs(62, 1.3, -0.25); }
}
</style>
